import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  apiUrl: string = '';

  constructor(private http: HttpClient) { }

  getConfig() {
    return new Promise<boolean>((resolve: (a: boolean) => void): void => {
      this.http.get('./assets/app.config.json').subscribe((config: any) => {
        this.apiUrl = config.apiUrl;
        resolve(true);
      }, error => {
        resolve(true);
      })
    });
  }

}
